import { render, staticRenderFns } from "./ReadView.vue?vue&type=template&id=70ed473c&"
import script from "./ReadView.vue?vue&type=script&lang=js&"
export * from "./ReadView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports